import React from "react";
import PolicyPage from "./PolicyPage";

const sections = [
  {
    title: "Basket storage",
    paragraphs: ["When a shopper adds an item, the browser writes a localStorage record named cartItems. It contains the product identifier, selected colour or size and quantity. This functional record lets the basket survive navigation and a later browser visit."],
  },
  {
    title: "Operational technologies",
    paragraphs: ["No optional measurement or advertising cookie is set by the reviewed shop source. Infrastructure may still apply mechanisms needed to deliver requests safely. Once Pay Now transfers control, the payment host can place cookies that preserve the transaction state and counter abuse in accordance with its own notice."],
  },
  {
    title: "Shopper controls and effect",
    paragraphs: ["Removing basket items updates the local record; clearing this site's browser storage removes it completely. A browser can also block storage or payment-provider cookies, but the basket may then fail to persist and hosted payment may not complete."],
  },
  {
    title: "Technology changes",
    paragraphs: ["Optional tracking must not be activated unless this notice and any consent control required for that technology are updated first. Questions about locating the basket record should identify the browser and device without including card information."],
  },
];

export default function CookiePolicy() {
  return <PolicyPage title="Cookie & Storage Notice" intro="How browser storage supports the cart and how the separate payment screen uses its own operational technology." sections={sections} related={[["Privacy Policy", "/privacy"], ["Consumer Data Rights", "/data-rights"]]} />;
}
